// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Image_placeholder__305HB","image":"Image_image__1Ms87 Image_placeholder__305HB","foreground":"Image_foreground__MvLvt"};